// extracted by mini-css-extract-plugin
module.exports = {"lsqSodicPageWrapper":"style_lsqSodicPageWrapper__Eywnv","lsqSodicPageBlock":"style_lsqSodicPageBlock__zNdSs","lsqSodicPageCommingSoon":"style_lsqSodicPageCommingSoon__i0CVt"};